import React from 'react';
import { Switch, Route } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline';
// import MainPage from './MainPage';
import MainPage from './HomeDashBoardPage';// merge MainPage file code into  HomeDashBoardPage on every server pull
import LoginPage from './LoginPage';
import LiveTracking from './LiveTracking';
import TermConditionPage from './TermConditionPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import RouteReportPage from './reports/RouteReportPage';
import PositionReportPage from './reports/PositionReportPage';
import ServerPage from './admin/ServerPage';
import UsersPage from './admin/UsersPage';
import DeviceModelsPage from './admin/DeviceModelsPage';
import VendorsPage from './admin/VendorsPage';
import BladesPage from './admin/BladesPage';
import DevicePage from './DevicePage';
import UserPage from './UserPage';
import VendorPage from './VendorPage';
import BladePage from './BladePage';
import DeviceModelPage from './DeviceModelPage';
import SocketController from './SocketController';
import NotificationsPage from './settings/NotificationsPage';
import NotificationPage from './settings/NotificationPage';
import GroupsPage from './settings/GroupsPage';
import GroupPage from './settings/GroupPage';
import PositionPage from './PositionPage';
import EventReportPage from './reports/EventReportPage';
import ReplayPage from './reports/ReplayPage';
import { useSelector } from 'react-redux';
import { LinearProgress } from '@material-ui/core';
import TripReportPage from './reports/TripReportPage';
import StopReportPage from './reports/StopReportPage';
import SummaryReportPage from './reports/SummaryReportPage';
import AcDurationReportPage from './reports/AcDurationReportPage';
import IgnitionDurationReportPage from './reports/IgnitionDurationReportPage';
import ChartReportPage from './reports/ChartReportPage';
import DriversPage from './settings/DriversPage';
import DriverPage from './settings/DriverPage';
import Loader from './LoadingIndicator';
import EventAlert from './EventAlert';
import GeoFencePage from "./reports/GeoFence";
import CanDataPage from "./reports/CanData";
import ComputedAttributesPage from "./admin/ComputedAttributes";
import ComputedAttributesAddPage from "./ComputedAttributesAddPage";
import BillingTransactionReportPage from './reports/BillingTransactionReportPage';
import AccountTransactionReport from './reports/AccountTransactionReport';
import GeofenceAddEditMap from './GeofenceAddEditMap';
import PointTransactionsReportPage from './reports/PointTransactionsReportPage';
import DevicesPage from './admin/DevicesPage';
import DevicesDocuments from './DevicesDocuments';
import OfflineReportPage from './reports/OfflineReportPage';
import OnlinePointTransactionsReportPage from './reports/OnlinePointTransactionsReportPage';
import OnlineAccountTransactionsReportPage from './reports/OnlineAccountTransactionsReportPage';

const App = () => {
  const initialized = useSelector(
    (state) => !!state.session.server && !!state.session.user
  );

  return (
    <>
      <CssBaseline />
      {/* <SocketController /> */}
      <Loader />
      <EventAlert />
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/termcondition" component={TermConditionPage} />
        <Route exact path="/privacypolicy" component={PrivacyPolicyPage} />
        <Route exact path="/livetracking" component={LiveTracking} />
        <Route>
          <SocketController />

          {!initialized ? (
            <LinearProgress />
          ) : (
            <Switch>
              <Route exact path="/" component={MainPage} />
              <Route exact path="/replay" component={ReplayPage} />
              <Route exact path="/position/:id?" component={PositionPage} />
              <Route exact path="/user/:id?/:deviceId?" component={UserPage} />
              <Route exact path="/vendors/:id?" component={VendorPage} />
              <Route exact path="/blades/:id?" component={BladePage} />
              <Route
                exact
                path="/computedattributes/:id?"
                component={ComputedAttributesAddPage}
              />

              <Route
                exact
                path="/deviceModels/:id?"
                component={DeviceModelPage}
              />
              <Route exact path="/device/:id?" component={DevicePage} />
              <Route
                exact
                path="/settings/notifications"
                component={NotificationsPage}
              />
              <Route
                exact
                path="/settings/notification/:id?"
                component={NotificationPage}
              />
              <Route exact path="/settings/groups" component={GroupsPage} />
              <Route exact path="/settings/group/:id?" component={GroupPage} />
              <Route exact path="/settings/drivers" component={DriversPage} />
              <Route
                exact
                path="/settings/driver/:id?"
                component={DriverPage}
              />
              <Route exact path="/admin/devices" component={DevicesPage} />
              <Route exact path="/admin/server" component={ServerPage} />
              <Route exact path="/admin/users" component={UsersPage} />
              <Route
                exact
                path="/admin/deviceModels"
                component={DeviceModelsPage}
              />
              <Route exact path="/admin/vendors" component={VendorsPage} />
              <Route exact path="/admin/blades" component={BladesPage} />
              <Route
                exact
                path="/admin/computedattributes"
                component={ComputedAttributesPage}
              />
              <Route exact path="/reports/route" component={RouteReportPage} />
              <Route
                exact
                path="/reports/position"
                component={PositionReportPage}
              />
              <Route exact path="/reports/event" component={EventReportPage} />
              <Route exact path="/reports/trip" component={TripReportPage} />
              <Route exact path="/reports/stop" component={StopReportPage} />
              <Route exact path="/reports/offlineDuration" component={OfflineReportPage} />
              <Route exact path="/reports/devicesdocuments" component={DevicesDocuments} />
              <Route
                exact
                path="/reports/summary"
                component={SummaryReportPage}
              />
              <Route
                exact
                path="/reports/acDuration"
                component={AcDurationReportPage}
              />
              <Route
                exact
                path="/reports/ignitionDuration"
                component={IgnitionDurationReportPage}
              />
              <Route exact path="/reports/chart" component={ChartReportPage} />
              <Route
                exact
                path="/reports/pointTransactions"
                component={PointTransactionsReportPage}
              />
              <Route
                exact
                path="/reports/onlinePointTransactions"
                component={OnlinePointTransactionsReportPage}
              />
              <Route
                exact
                path="/reports/billingTransactions"
                component={BillingTransactionReportPage}
              />
              <Route
                exact
                path="/reports/accountTransactions"
                component={AccountTransactionReport}
              />
              <Route
                exact
                path="/reports/onlineAccountTransactions"
                component={OnlineAccountTransactionsReportPage}
              />
              <Route exact path="/reports/geofence" component={GeoFencePage} />
              <Route exact path="/geofence/:id?" component={GeofenceAddEditMap} />
              <Route exact path="/reports/candata" component={CanDataPage} />
            </Switch>
          )}
        </Route>
      </Switch>
    </>
  );
};

export default App;
